import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import DateFns from "date-fns";
import ReferCandidate from "./referCandidate";
import AddApplyJobs from "./applyJobs";
import { addApplyJobs } from "../../redux/action/jobs/apply_jobsAction";
import { getProfileInfo } from "../../redux/action/profileInfoAction";
import CommonFlexComponent from "../../common/commonFlexComponent";
// import {} from 'react-bootstrap'

import { Row, Col, Button } from "reactstrap";
// import react icons
import { AiFillTags } from "react-icons/ai";
import { GrFormView } from "react-icons/gr";
import { BsFillShareFill } from "react-icons/bs";

class ParticularJobs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      edit: false,
      isUpdate: false,
      referPopUp: false,
      viewShowPopup: false,
      message: "",
      error: "",
      getData: [],
      dataStore: [],
      showPopUp: false,
      showApplyJobPopUp: false,
      taggedView: false,
      searchValue: "",
      selectedOptionError: null,
      selectedOptionErrorOne: null,
      changeError: "",
    };
    this.handleViewOpenReferCandi = this.handleViewOpenReferCandi.bind(this);
    this.closeReferPopUp = this.closeReferPopUp.bind(this);
    this.handleApplyView = this.handleApplyView.bind(this);
    this.handleApplyClose = this.handleApplyClose.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  //  componentDidUpdate(prevProps,prevState) {
  //   if(prevState !== this.state.edit){
  //   refresh();
  //   }

  //   }

  // common onchange

  // close function
  backnavigate() {
    this.setState({
      edit: false,
    });
    this.props.getJobs();
  }

  handlePopupView() {
    this.setState({
      boardPopUp: true,
    });
  }

  closeReferPopUp() {
    this.setState({
      referPopUp: false,
    });
  }

  handleViewOpenReferCandi() {
    this.setState({
      referPopUp: !this.state.referPopUp,
      showApplyJobPopUp: false,
    });
  }

  handleApplyView() {
    this.setState({
      showApplyJobPopUp: !this.state.showApplyJobPopUp,
      referPopUp: false,
    });
  }

  handleApplyClose() {
    this.setState({
      showApplyJobPopUp: false,
    });
  }

  handleCloseViewBoard() {
    this.setState({
      viewShowPopup: false,
    });
  }

  onSubmit(e) {
    e.preventDefault();
    // submitValidator(e.target);
    let data = {
      jobReqirementId: this.props.storeData[0].jobRequirementId,
      jobId: this.props.storeData[0].id,
      canInfoId: this.props.profile.data.id,
      canUserId: this.props.profile.data.canUserId,
      candidateSource: "online",
      candidateStatus: "Applied",
    };
    this.props.addApplyJobs(data, this.props.back);
  }

  componentDidMount() {
    this.props.getProfileInfo();
  }

  render() {
    return (
      <Row>
        <div>
          <i
            data-toggle="tooltip"
            data-placement="top"
            title="Close"
            onClick={() => this.props.back()}
            className="material-icons pointer cancel-button"
          >
            cancel
          </i>
        </div>

        {!this.state.edit ? (
          <Col md="12">
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
              }}
            >
              <h3
                data-toggle="tooltip"
                data-placement="top"
                title="Refer Candidate"
                onClick={this.handleViewOpenReferCandi}
                style={{ color: "#04044c", marginRight: "1.5rem" }}
              >
                {" "}
                <BsFillShareFill size="25" />{" "}
              </h3>
              {/* <h3
                data-toggle="tooltip"
                data-placement="top"
                title="Apply Jobs"
                onClick={this.handleApplyView}
                style={{ color: "#04044c", marginRight: "1.5rem" }}
              >
                {" "}
                <AiFillTags />{" "}
              </h3> */}
            </div>

            <h5
              style={{ fontSize: "1.25rem", fontWeight: "500" }}
              className="bold center mb-4"
            >
              {" "}
              Job Id :
              {this.props.storeData.length > 0 && this.props.storeData[0].id}
            </h5>
            {this.state.referPopUp && (
              <ReferCandidate
                reqId={this.props.storeData[0].jobRequirement}
                // jobId={this.props.storeData.length >0 && this.props.storeData[0].id}
                showPopUp={this.state.referPopUp}
                handleCloseModal={this.closeReferPopUp}
              />
            )}

            {this.state.showApplyJobPopUp && (
              <AddApplyJobs
                reqId={this.props.storeData[0].jobRequirement}
                jobId={this.props.storeData[0].id}
                showPopUp={this.state.showApplyJobPopUp}
                handleCloseModal={this.handleApplyClose}
              />
            )}

            {this.props.storeData.length > 0 &&
              this.props.storeData.map((data) => {
                return (
                  <div>
                    {/* <Row>
                      <Col md="6">
                        <ul class="CustDetails-ul">
                          <li
                            style={{
                              display: "flex",
                              alignItems: "end",
                              marginTop: "0.5rem",
                            }}
                          >
                            <div
                              class="label-sm bold rs-req-span-label-col-1 pt-1"
                              style={{ width: "30%" }}
                            >
                              <span
                                style={{
                                  fontSize: "14px",
                                  fontWeight: "500",
                                }}
                              >
                                Req. Type
                              </span>
                            </div>
                            <div style={{ width: "5%", textAlign: "end" }}>
                              <span class="label-sm">:</span>
                            </div>
                            <div style={{ width: "55%", paddingLeft: " 5%" }}>
                              <span class=" label-sm">{data.jobType}</span>
                            </div>
                          </li>
                          <li
                            style={{
                              display: "flex",
                              alignItems: "end",
                              marginTop: "0.5rem",
                            }}
                          >
                            <div
                              class="label-sm bold rs-req-span-label-col-1 pt-1"
                              style={{ width: "30%" }}
                            >
                              <span
                                style={{
                                  fontSize: "14px",
                                  fontWeight: "500",
                                }}
                              >
                                Job Category
                              </span>
                            </div>
                            <div style={{ width: "5%", textAlign: "end" }}>
                              <span class="label-sm">:</span>
                            </div>
                            <div style={{ width: "55%", paddingLeft: " 5%" }}>
                              <span class=" label-sm">{data.jobCategory}</span>
                            </div>
                          </li>

                          <li
                            style={{
                              display: "flex",
                              alignItems: "end",
                              marginTop: "0.5rem",
                            }}
                          >
                            <div
                              class="label-sm bold rs-req-span-label-col-1 pt-1"
                              style={{ width: "30%" }}
                            >
                              <span
                                style={{
                                  fontSize: "14px",
                                  fontWeight: "500",
                                }}
                              >
                                Primary Skills
                              </span>
                            </div>
                            <div style={{ width: "5%", textAlign: "end" }}>
                              <span class="label-sm">:</span>
                            </div>
                            <div style={{ width: "55%", paddingLeft: " 5%" }}>
                              <span class=" label-sm">{data.primarySkills}</span>
                            </div>
                          </li>
                        
                         
                          
                          <li
                            style={{
                              display: "flex",
                              alignItems: "end",
                              marginTop: "0.5rem",
                            }}
                          >
                            <div
                              class="label-sm bold rs-req-span-label-col-1 pt-1"
                              style={{ width: "30%" }}
                            >
                              <span
                                style={{
                                  fontSize: "14px",
                                  fontWeight: "500",
                                }}
                              >
                               Secondary Skills
                              </span>
                            </div>
                            <div style={{ width: "5%", textAlign: "end" }}>
                              <span class="label-sm">:</span>
                            </div>
                            <div style={{ width: "55%", paddingLeft: " 5%" }}>
                              <span class=" label-sm">{data.secondarySkills}</span>
                            </div>
                          </li>
                        
                          <li
                            style={{
                              display: "flex",
                              alignItems: "end",
                              marginTop: "0.5rem",
                            }}
                          >
                            <div
                              class="label-sm bold rs-req-span-label-col-1 pt-1"
                              style={{ width: "30%" }}
                            >
                              <span
                                style={{
                                  fontSize: "14px",
                                  fontWeight: "500",
                                }}
                              >
                                Job Timing
                              </span>
                            </div>
                            <div style={{ width: "5%", textAlign: "end" }}>
                              <span class="label-sm">:</span>
                            </div>
                            <div style={{ width: "55%", paddingLeft: " 5%" }}>
                              <span class=" label-sm">
                              {data.JobTimings}
                              </span>
                            </div>
                          </li>
                          <li
                            style={{
                              display: "flex",
                              alignItems: "end",
                              marginTop: "0.5rem",
                            }}
                          >
                            
                          </li>
                          <li
                            style={{
                              display: "flex",
                              alignItems: "end",
                             
                            }}
                          >
                            <div
                              class="label-sm bold rs-req-span-label-col-1 pt-1"
                              style={{ width: "30%" }}
                            >
                              <span
                                style={{
                                  fontSize: "14px",
                                  fontWeight: "500",
                                }}
                              >
                                Job Description
                              </span>
                            </div>
                            <div style={{ width: "5%", textAlign: "end" }}>
                              <span class="label-sm">:</span>
                            </div>
                            <div style={{ width: "55%", paddingLeft: " 5%" }}>
                              <span class=" label-sm">{data.jobDescription}</span>
                            </div>
                          </li>
                        </ul>
                      </Col>
                      <Col md="6">
                        <ul className="CustDetails-ul">
                          <li
                            style={{
                              display: "flex",
                              alignItems: "end",
                              marginTop: "0.5rem",
                            }}
                          >
                            <div
                              class="label-sm bold rs-req-span-label-col-1 pt-1"
                              style={{ width: "30%" }}
                            >
                              <span
                                style={{
                                  fontSize: "14px",
                                  fontWeight: "500",
                                }}
                              >
                                Job Location
                              </span>
                            </div>
                            <div style={{ width: "5%", textAlign: "end" }}>
                              <span class="label-sm">:</span>
                            </div>
                            <div style={{ width: "55%", paddingLeft: " 5%" }}>
                              <span class=" label-sm">{data.jobLocation}</span>
                            </div>
                          </li>
                          <li
                            style={{
                              display: "flex",
                              alignItems: "end",
                              marginTop: "0.5rem",
                            }}
                          >
                            <div
                              class="label-sm bold rs-req-span-label-col-1 pt-1"
                              style={{ width: "30%" }}
                            >
                              <span
                                style={{
                                  fontSize: "14px",
                                  fontWeight: "500",
                                }}
                              >
                               Job Position
                              </span>
                            </div>
                            <div style={{ width: "5%", textAlign: "end" }}>
                              <span class="label-sm">:</span>
                            </div>
                            <div style={{ width: "55%", paddingLeft: " 5%" }}>
                              <span class=" label-sm">
                              {data.jobPosition}
                              </span>
                            </div>
                          </li>
                          <li
                            style={{
                              display: "flex",
                              alignItems: "end",
                              marginTop: "0.5rem",
                            }}
                          >
                            <div
                              class="label-sm bold rs-req-span-label-col-1 pt-1"
                              style={{ width: "30%" }}
                            >
                              <span
                                style={{
                                  fontSize: "14px",
                                  fontWeight: "500",
                                }}
                              >
                                Qualification
                              </span>
                            </div>
                            <div style={{ width: "5%", textAlign: "end" }}>
                              <span class="label-sm">:</span>
                            </div>
                            <div style={{ width: "55%", paddingLeft: " 5%" }}>
                              <span class=" label-sm">
                              {data.qualifications}
                              </span>
                            </div>
                          </li>
                          <li
                            style={{
                              display: "flex",
                              alignItems: "end",
                              marginTop: "0.5rem",
                            }}
                          >
                            <div
                              class="label-sm bold rs-req-span-label-col-1 pt-1"
                              style={{ width: "30%" }}
                            >
                              <span
                                style={{
                                  fontSize: "14px",
                                  fontWeight: "500",
                                }}
                              >
                                Start Date
                              </span>
                            </div>
                            <div style={{ width: "5%", textAlign: "end" }}>
                              <span class="label-sm">:</span>
                            </div>
                            <div style={{ width: "55%", paddingLeft: " 5%" }}>
                              <span class=" label-sm">
                                {data.startDate
                              ? DateFns.format(data.startDate, "DD-MM-YYYY")
                              : ""}
                              </span>
                            </div>
                          </li>
                         
                          <li
                            style={{
                              display: "flex",
                              alignItems: "end",
                              marginTop: "0.5rem",
                            }}
                          >
                            <div
                              class="label-sm bold rs-req-span-label-col-1 pt-1"
                              style={{ width: "30%" }}
                            >
                              <span
                                style={{
                                  fontSize: "14px",
                                  fontWeight: "500",
                                }}
                              >
                                End Date
                              </span>
                            </div>
                            <div style={{ width: "5%", textAlign: "end" }}>
                              <span class="label-sm">:</span>
                            </div>
                            <div style={{ width: "55%", paddingLeft: " 5%" }}>
                              <span class=" label-sm">
                              {data.endDate
                              ? DateFns.format(data.endDate, "DD-MM-YYYY")
                              : ""}
                              </span>
                            </div>
                          </li>
                          <li
                            style={{
                              display: "flex",
                              alignItems: "end",
                              marginTop: "0.5rem",
                            }}
                          >
                            <div
                              class="label-sm bold rs-req-span-label-col-1 pt-1"
                              style={{ width: "30%" }}
                            >
                              <span
                                style={{
                                  fontSize: "14px",
                                  fontWeight: "500",
                                }}
                              >
                                Years Of Exp
                              </span>
                            </div>
                            <div style={{ width:"6%", textAlign: "end" }}>
                              <span class="label-sm">:</span>
                            </div>
                            <div style={{ width: "77%", paddingLeft: " 5%" }}>
                              <span class=" label-sm">
                              {data.minYearsOfExp} - {data.maxYearsOfExp}
                              </span>
                            </div>
                          </li>
                        </ul>
                      </Col>
                      <div className="center">
                    <Button
                     onClick={this.onSubmit}
                     tabIndex="9"
                      type="submit"
                      style={{
                        background: "#0984e3",
                      
                        color: "white",
                      }}
                      className="btn login-button white-text"
                    >
                      Apply Jobs
                    </Button>
                  </div>
                    </Row>  */}
                    {/* <hr class="MuiDivider-root" />
                    <div class="jss3" style={{ fontSize: "12px" }}>
                      <span class="MuiTypography-root MuiTypography-caption MuiTypography-colorTextSecondary">
                        Created By {data.createdBy} on {data.createdOn} and
                        Updated By {data.updatedBy} on {data.updatedOn}
                      </span>
                    </div> */}
                    {/* <Divider />
                    <DetailsPageFooter
                      createdBy={data.createdBy}
                      createdOn={data.createdOn}
                      updatedBy={data.updatedBy}
                      updatedOn={data.updatedOn}
                    />

                    <Row style={{ width:'100%'}}>
                      <Col md='5'>
                      <ul>
                        <li>
                          <label>Req.type</label>
                          {data.jobType}

                        </li>

                      </ul>
                      </Col>
                    </Row>  */}

                    <Row style={{ width: "100%" }}>
                      <Col >
                        <ul>
                          <li>
                            <CommonFlexComponent
                              label="Req ID"
                              data={data.jobType}
                            />
                          </li>
                          <li>
                            <CommonFlexComponent
                              label="Job Category"
                              data={data.jobCategory}
                            />
                          </li>
                          <li>
                            <CommonFlexComponent
                              label="Primary Skills"
                              data={data.primarySkills}
                            />
                          </li>
                          <li>
                            <CommonFlexComponent
                              label="Secondary Skills"
                              data={data.secondarySkills}
                            />
                          </li>
                          <li>
                            <CommonFlexComponent
                              label="Job Timing"
                              data={data.JobTimings}
                            />
                          </li>
                          <li>
                            <CommonFlexComponent
                              label="Job Description"
                              data={data.jobDescription}
                            />
                          </li>
                        </ul>
                      </Col>

                      <Col >
                      <ul>
                        <li>
                        <CommonFlexComponent
                              label="Job Location"
                              data={data.jobLocation}
                            />

                        </li>
                        <li>
                        <CommonFlexComponent
                              label="Job Position"
                              data={data.jobPosition}
                            />

                        </li>
                        <li>
                        <CommonFlexComponent
                              label="Qualification"
                              data={data.qualifications}
                            />

                        </li>
                        <li>
                        <CommonFlexComponent
                              label="Start Date"
                              data={data.startDate
                                ? DateFns.format(data.startDate, "DD-MM-YYYY")
                                : ""}
                            />

                        </li>
                        <li>
                        <CommonFlexComponent
                              label="End Date"
                              data=  {data.endDate
                                ? DateFns.format(data.endDate, "DD-MM-YYYY")
                                : ""}
                            />

                        </li>
                        <li>
                        <CommonFlexComponent
                              label="Year Of Exp"
                              data=  {data.maxYearsOfExp}
                            />

                        </li>
                      </ul>
                      
                      </Col>
                      <div className="center">
                    <Button
                     onClick={this.onSubmit}
                     tabIndex="9"
                      type="submit"
                      style={{
                        background: "#0984e3",
                      
                        color: "white",
                      }}
                      className="btn login-button white-text"
                    >
                      Apply Jobs
                    </Button>
                  </div>
                    </Row>
                  </div>
                );
              })}
          </Col>
        ) : (
          <Row></Row>
        )}

        {/* {this.props.PublishJobs.message ? <Notifier message={this.props.PublishJobs.message} /> : null}
        {this.props.PublishJobs.error ? <ErrorNotifier message={this.props.PublishJobs.error} /> : null} */}
        {/* {this.state.message ? (
          <Notifier message={this.state.message} />
        ) : null}
        {this.state.error ? (
          <ErrorNotifier message={this.state.error} />
        ) : null} */}
      </Row>
    );
  }
}

ParticularJobs.propTypes = {};

const mapStateToProps = (state) => ({
  profile: state.profile,
  PublishJobs: state.PublishJobs,
  ApplyJobs: state.ApplyJobs,
});

export default connect(mapStateToProps, { addApplyJobs, getProfileInfo })(
  withRouter(ParticularJobs)
);
